module.exports = __webpack_public_path__ + "img/439-712387.png";